import { render } from "./QuestionComponent.vue?vue&type=template&id=37e771e4&scoped=true"
import script from "./QuestionComponent.vue?vue&type=script&lang=js"
export * from "./QuestionComponent.vue?vue&type=script&lang=js"

import "./QuestionComponent.vue?vue&type=style&index=0&id=37e771e4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e771e4"]])

export default __exports__